<template>
  <div class="trial-surgeon-table">
    <div class="table-container">
      <div class="inner-scroll">
        <table>
          <thead>
            <td v-for="(heading, keyIndex) in headers" :key="keyIndex" >
              {{heading}}
            </td>
          </thead>
          <tbody>
            <tr v-for="(row, rowIndex) in trialSurgeons" :key="rowIndex" @click="onRowClick(row)" >
              <td v-for="(key, keyIndex) in columns" :key="keyIndex" >
                {{row[key]}}
              </td>
              <td>
                <rp-button @click.stop="onView(row)">View Profile</rp-button>
              </td>
              <td v-if="isTrialContext">
                <rp-button @click.stop="onRemove(row)">Remove from Study</rp-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Button from './inputs/Button'
import Pagination from './Pagination'

export default {
  components: {
    'rp-button': Button,
    'rp-pagination': Pagination,
  },

  data() {
    return {
      trialCols: ['name', 'email', 'enrolment_target'],
      allTrialCols: ['name', 'email', 'enrolled', 'active'],
      trialHeads: ['Name', 'E-Mail Address', 'Enrolment Target'],
      allTrialHeads: ['Name', 'E-Mail Address', 'Studies Enrolled', 'Studies Active'],
    }
  },

  props: {
    trialSurgeons: Array,
  },

  computed: {
    headers() {
      return this.isTrialContext ? this.trialHeads : this.allTrialHeads
    },

    columns() {
      return this.isTrialContext ? this.trialCols : this.allTrialCols
    },

    isTrialContext() {
      return this.trialSurgeons.length > 0 && this.trialSurgeons[0].enrolment_target != null
    },
  },

  methods: {
    onRowClick(row) {
      this.$emit('onRowClick', row)
    },

    onView(row) {
      this.$emit('onView', row)
    },

    onRemove(row) {
      this.$emit('onRemove', row)
    },
  },
}
</script>

<style lang="sass" scoped>
  @import '../../styles/base/_variables.sass'
  @import '../../styles/helpers/_mixins.sass'
  @import '../../styles/base/_themes.scss'

  .trial-surgeon-table
    color: $color-text
    background-color: $color-panel-bg
    border-radius: 10px

    button
      margin-top: 0

    table
      padding: 10px
      width: 100%
      border-collapse: collapse
      table-layout: fixed

      td
        &.tdbutton
          width: 20px

        .status
          display: block

        div
          span
            display: flex
            justify-content: center

    thead
      @include themify($themes)
        background: themed('thead-background')
        color: themed('thead-color')

      font-weight: bold
      text-transform: uppercase
    
      td
        white-space: nowrap
        line-height: 1

        &.tdbutton
          text-align: center

        @include themify($themes)
          padding: themed('thead-td-padding')
          font-weight: themed('thead-td-weight')
          font-size: themed('thead-font-size')
          
        &:first-child 
          @include themify($themes)
            border-radius: themed('td-radius-left')

        &:last-child
          @include themify($themes)
            border-radius: themed('td-radius-right')

    tr
      @include themify($themes)
        border-bottom: themed('tr-border-bottom')
    
      &:first-child
        @include themify($themes)
          border-top: themed('tr-border-top')
      &:last-child
        @include themify($themes)
          border-bottom: 0
      td
        @include themify($themes)
          padding: themed('td-padding')
        
        font-size: 12px

    .pagination
      @include themify($themes)
        border-top: themed('tr-border-top')
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/TrialSurgeonTable.vue